// ============================================================================
// JAPANESE TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// 信仰についての思索的で興味深い質問

export const funQuestions = [
  {
    question: "イエスの愛の行いで、あなたの日常生活に最も感動を与えるものは何ですか？",
    emoji: "❤️",
    theme: "愛"
  },
  {
    question: "聖書の人物と食事を共にできるとしたら、誰を選びますか、そしてその理由は？",
    emoji: "🍞",
    theme: "出会い"
  },
  {
    question: "イエスのたとえ話で、最も深くあなたに語りかけるものは何ですか、そしてその理由は？",
    emoji: "🌱",
    theme: "教え"
  },
  {
    question: "神の平安はあなたの生活の中でどのように現れていますか？",
    emoji: "🕊️",
    theme: "平安"
  },
  {
    question: "イエスの奇跡の中で、目撃したかったものは何ですか？",
    emoji: "✨",
    theme: "信仰"
  },
  {
    question: "神の愛を一言で表すとしたら、どんな言葉を選びますか？",
    emoji: "💝",
    theme: "神の愛"
  },
  {
    question: "困難な時にあなたを助けた聖句は何ですか？",
    emoji: "📖",
    theme: "慰め"
  },
  {
    question: "今日、どのように世の光となることができますか？",
    emoji: "💡",
    theme: "証し"
  }
];

export default funQuestions;
